import actionTypes from "./actionTypes"
const getInitialState = () => ({
  retailerId: "",
  retailerProducts: [],
  retailerLoaded: false,
  retailerLoading: false,
})

export function reducer(state = getInitialState(), action) {
  switch (action.type) {
    case actionTypes.SET_RETAILER:
      return {
        ...state,
        retailerProducts: action.retailerProducts,
        retailerId: action.retailerId,
        retailerLoaded: true,
        retailerLoading: false,
      }
    default:
      return state
  }
}
